import url from '../url'
import headers from '../headers'

export default {
	getAll (context, user_uid, watch_id, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/healthreports/?size=${size}`,
			headers.bearer()
		)
	},
	get (context, user_uid, watch_id, id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/healthreports/${id}`,
			headers.bearer()
		)
	},
	add (context, user_uid, watch_id, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/watches/${watch_id}/healthreports`,
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, watch_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/watches/${watch_id}/healthreports/${model.id}`,
			model,
			headers.bearer()
		)
	},
	delete (context, user_uid, watch_id, id) {
		return context.$http.delete(
			`${url}/users/${user_uid}/watches/${watch_id}/healthreports/${id}`,
			headers.bearer()
		)
	},
	attachments: {
		delete (context, user_uid, watch_id, report_id, id) {
			return context.$http.delete(
				`${url}/users/${user_uid}/watches/${watch_id}/healthreports/${report_id}/attachments/${id}`,
				headers.bearer()
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/healthreports.js